import { Grid, Typography } from '@mui/material';
import Layout from '../../../components/pages/directory/Layout';
import React, { useEffect } from 'react';

import { FilterPanel } from '../../../components/pages/directory/filter-panel';
import { FormContainer } from 'react-hook-form-mui';
import { NextHead } from '../../../components/NextHead';
import { CompaniesFiltersDto } from '../../../services/directoryService';
import { useCompaniesDirectoryList } from '../../../components/pages/directory/useCompaniesDirectoryList';
import { LoadingIndicator } from '../../../components/LoadingIndicator';
import { CompanyCard } from '../../../components/pages/directory/CompanyCard';
import { Paginator } from '../../../components/Paginator';
import { FormInitializer } from '../../../components/FormInitializer';
import Link from 'next/link';
import { routes } from '../../../config/routes';
import { getStaticPropsWithTranslations } from '../../../utils/translation';
import { useTranslation } from 'next-i18next';
import { useUnreadCompanies } from '../../../components/NavBar/useNavbarNotifications';

const nameSpaces = [
  'directory',
  'purchase-announcements',
  'common',
  'my-companies',
];
const DirectoryPageContainer = () => {
  const {
    filters,
    query: { data: companiesRes, isLoading },
    applyFilters,
    handleOffsetChange,
  } = useCompaniesDirectoryList();
  const { invalidate } = useUnreadCompanies();

  useEffect(() => {
    invalidate();
  }, []);

  const { t } = useTranslation(nameSpaces);
  const onApplyFilters = (values: CompaniesFiltersDto) => {
    applyFilters(values);
  };

  return (
    <>
      <NextHead pageName={t('directory:list:title')} />
      <FormContainer<CompaniesFiltersDto>
        onSuccess={onApplyFilters}
        defaultValues={{ categories: [null, '-1'] }}
      >
        <FormInitializer initialValues={filters} />
        <Layout
          infoSection={
            <Typography variant="h6">
              {companiesRes?.data?.total || 0}{' '}
              {t('directory:list:search:companies')}
            </Typography>
          }
        >
          <Grid item xs={12} md={4} lg={3}>
            <FilterPanel />
          </Grid>
          <Grid
            container
            item
            xs={12}
            md={8}
            lg={9}
            spacing={2}
            alignItems="flex-start"
            alignContent="flex-start"
          >
            {isLoading ? (
              <Grid item container xs={12} justifyContent="center">
                <LoadingIndicator />
              </Grid>
            ) : companiesRes?.data?.total === 0 ? (
              <>
                <Grid item container xs={12} justifyContent="center">
                  <Typography variant="h5" mt={6} color="textSecondary">
                    {t('directory:list:search:noMatches')}
                  </Typography>
                </Grid>
                <Grid item container xs={12} justifyContent="center">
                  <Typography variant="body1" color="textSecondary">
                    {t('directory:list:search:try')}
                  </Typography>
                </Grid>
                <Grid item container xs={12} justifyContent="center">
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    textAlign="center"
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: t('directory:list:invitation'),
                      }}
                    />
                    <Link
                      target="_blank"
                      href={`${routes.CONNECT_AMERICAS}/page/search?qt-search_tabs_container=1&f%5B0%5D=field_company_industry_tax%3A1875`}
                      style={{ textDecoration: 'underline' }}
                    >
                      ConnectAmericas
                    </Link>
                  </Typography>
                </Grid>
              </>
            ) : (
              companiesRes?.data?.items?.map((c) => (
                <Grid item xs={12} key={c.company.id}>
                  <CompanyCard company={c} />
                </Grid>
              ))
            )}
          </Grid>
          <Grid container item xs={12} justifyContent="flex-end">
            <Paginator
              itemsPerPage={filters.items_per_page}
              offset={filters.offset}
              offsetChange={handleOffsetChange}
              total={companiesRes?.data?.total}
              blockSecondPageIfNotAuthenticated
            />
          </Grid>
        </Layout>
      </FormContainer>
    </>
  );
};

export const getStaticProps = getStaticPropsWithTranslations(nameSpaces);
export default DirectoryPageContainer;
